import { useEffect, useState } from "react";

type Visit = { event: string; at: string; ip: string; location: string; browser: string };
const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api/proposal/visits` : "";

function fmt(iso: string) {
  return new Date(iso).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" });
}

export default function VisitsPage() {
  const [rows, setRows] = useState<Visit[] | null>(null);
  const [denied, setDenied] = useState(false);
  useEffect(() => {
    const key = new URLSearchParams(window.location.search).get("key") ?? "";
    if (!API || !key) { setDenied(true); return; }
    fetch(`${API}?key=${encodeURIComponent(key)}`)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((d) => setRows(Array.isArray(d?.events) ? d.events : []))
      .catch(() => setDenied(true));
  }, []);

  return (
    <main className="amat min-h-screen bg-white px-5 py-12 sm:px-10" data-testid="visits-page">
      <h1 className="am-title text-3xl sm:text-4xl">Proposal visit log</h1>
      <p className="mt-2 text-sm">Every open of the private proposal link and every PDF download, newest first. Locations are approximate, based on IP address.</p>
      {denied && <p className="mt-8 text-base" data-testid="visits-denied">This page is not available.</p>}
      {rows && rows.length === 0 && <p className="mt-8" data-testid="visits-empty">No visits yet.</p>}
      {rows && rows.length > 0 && (
        <div className="mt-8 overflow-x-auto">
          <table className="w-full min-w-[720px] border-collapse text-left text-sm" data-testid="visits-table">
            <thead><tr className="bg-[var(--am-yellow)] text-[#2b2d30]">
              {["Date and time", "Event", "Location", "IP address", "Browser"].map((h) => <th key={h} className="px-3 py-2.5 font-semibold">{h}</th>)}
            </tr></thead>
            <tbody>
              {rows.map((v, i) => (
                <tr key={i} className="border-b border-[#c9cbcd] align-top" data-testid={`visits-row-${i}`}>
                  <td className="whitespace-nowrap px-3 py-2">{fmt(v.at)}</td>
                  <td className="px-3 py-2 font-semibold text-[#2b2d30]">{v.event.replace("Private proposal link opened", "Link opened").replace("Proposal PDF downloaded", "PDF downloaded")}</td>
                  <td className="px-3 py-2">{v.location || "Unknown"}</td>
                  <td className="px-3 py-2 tabular-nums">{v.ip}</td>
                  <td className="max-w-[320px] px-3 py-2 text-xs">{v.browser}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </main>
  );
}
